import { AccountStatusResponse } from "@/types/FirebaseFunctionsResponses";
import { Functions, httpsCallable } from "firebase/functions";

export class AccountStatusApiService {
  private functions: Functions;

  constructor(functions: Functions) {
    this.functions = functions;
  }

  getAccountStatus = async (accountId: string): Promise<AccountStatusResponse | undefined> => {
    try{
      const getAccountStatus = httpsCallable(this.functions, 'getAccountStatus');
      const result = await getAccountStatus({"accountId": accountId});
      const response: AccountStatusResponse = result.data as AccountStatusResponse;
      
      console.log("firebaseFunctionsApi.getAccountStatus response:", response);

      return response; 
    }
    catch(e){
      console.error("UserAccountsApi.getAccounts error:", e);
      return undefined;
    }
  }
}